import type { IconProps } from '.';

/**
 * Arrow Right Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const ArrowRightIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.7929 11.5L11.6464 7.35356L12.3536 6.64645L17.7071 12L12.3536 17.3536L11.6464 16.6465L15.7929 12.5H7V11.5H15.7929Z"
      fill="white"
    />
  </svg>
);

export default ArrowRightIcon;
